import { render, staticRenderFns } from "./latest-orders.vue?vue&type=template&id=40f4d148"
import script from "./latest-orders.vue?vue&type=script&lang=js"
export * from "./latest-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports